export default "__VITE_ASSET__722af890__"